// extracted by mini-css-extract-plugin
module.exports = {"EpCountdown":"CountdownTime_EpCountdown__282yP"};